"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomationsRoutingKey = void 0;
var AutomationsRoutingKey;
(function (AutomationsRoutingKey) {
    AutomationsRoutingKey["Appointment_ClientArrival"] = "Appointment_ClientArrival";
    AutomationsRoutingKey["Appointment_ConfirmReminder"] = "Appointment_ConfirmReminder";
    AutomationsRoutingKey["Appointment_Followup"] = "Appointment_Followup";
    AutomationsRoutingKey["Appointment_Pims_Sync"] = "Appointment_Pims_Sync";
    AutomationsRoutingKey["Appointment_Reminder"] = "Appointment_Reminder";
    AutomationsRoutingKey["Appointment_Scheduled"] = "Appointment_Scheduled";
    AutomationsRoutingKey["CallDeflection_FormSubmitted"] = "CallDeflection_FormSubmitted";
    AutomationsRoutingKey["Fire_Next_Automation_Run_Action"] = "FIRE_NEXT_AUTOMATION_RUN_ACTION";
    AutomationsRoutingKey["HillsToHome"] = "HillsToHome";
    AutomationsRoutingKey["LapsedPetParent"] = "LapsedPetParent";
    AutomationsRoutingKey["ServiceReminder_FormSubmitted"] = "ServiceReminder_FormSubmitted";
    AutomationsRoutingKey["Trigger_WorkflowAction"] = "TRIGGER_WORKFLOWACTION";
    AutomationsRoutingKey["WidgetRequest_FormSubmitted"] = "WidgetRequest_FormSubmitted";
})(AutomationsRoutingKey = exports.AutomationsRoutingKey || (exports.AutomationsRoutingKey = {}));
//# sourceMappingURL=types.js.map